// extracted by mini-css-extract-plugin
export default {"btn_zamknij":"ZamknijWykonanieBtn_btn_zamknij__nvgAm"};